// src/text.ts
import { Node } from "@tiptap/core";
var Text = Node.create({
  name: "text",
  group: "inline"
});

// src/index.ts
var index_default = Text;
export {
  Text,
  index_default as default
};
//# sourceMappingURL=index.js.map